module.exports = __webpack_public_path__ + "static/media/Eth.f85c171c.svg";